export default {
    en: {
        title: 'Specifications',
        design: 'Design',
        quality: 'Quality',
        category: 'Category',
        color: 'Color',
        dimension: 'Dimension',
        total: 'Total',
        importPrice: 'Import Price',
        salePrice: 'Sale Price',
        inStock: 'In Stock',
        info: 'Extra information',
        buttons: {
            sale: 'Sell Now',
            edit: 'Edit',
            deleteBtn: 'Delete',
            qr: 'QR Code'
        },
        alert: {
            title: "Are you sure?",
            text: "Do you really want to delete the sale?",
            yesBtn: 'Yes, delete it!',
            cancel: "Cancel!"
        },

    },
    uz: {
        title: 'Ma\'lumotlar',
        design: 'Dizayn',
        quality: 'Sifati',
        category: 'Kategoriya',
        color: 'Rangi',
        dimension: 'O\'lchamlari',
        total: 'Umumiy',
        importPrice: 'Import narxi',
        salePrice: 'Sotish narxi',
        inStock: 'Omborda',
        info: "Qo'shimcha ma'lumotlar",
        buttons: {
            sale: 'Sotish',
            edit: 'Tahrirlash',
            deleteBtn: 'O\'chirish',
            qr: 'QR Kod'
        },
        alert: {
            title: "Bunga aminmisiz?",
            text: "Haqiqatan ham xaridni yo'q qilmoqchimisiz?",
            yesBtn: "Ha, o'chir!",
            cancel: "Bekor qil!"
        }
    },
    ru: {
        title: 'Характеристики',
        design: 'Дизайн',
        quality: 'Качество',
        category: 'Категория',
        color: 'Цвет',
        dimension: 'Размер',
        total: 'Общий размер',
        importPrice: 'Импортная цена',
        salePrice: 'Цена продажи',
        inStock: 'В склад',
        info: 'Дополнительная информация',
        buttons: {
            sale: 'Продать',
            edit: 'Редактировать',
            deleteBtn: 'Удалять',
            qr: 'QR Код'
        },
        alert: {
            title: "Вы уверены?",
            text: "Вы действительно хотите удалить продажу?",
            yesBtn: 'Да, удали это!',
            cancel: "Отмена!"
        },
    },
}